import { AMENITIES } from "../amenities";

/**
 * Stateless amenity-picker grid. Drop-in for the Add-Trail surfaces
 * (AddTrailDrawer + AdminAddTrail ProposeMode) so a curator can
 * bootstrap parking / restrooms / etc. at create time.
 *
 * Parent owns the `Set<string>` of selected keys + the toggle handler.
 * This component just renders the chips and calls back on tap. No
 * network calls happen here — the parent batches the selected keys
 * into the proposeTrail({ amenities }) request.
 *
 * Reuses the AmenitiesEditor's chip styling (.amenities-grid +
 * .amenity-chip + .amenity-icon + .amenity-label) so the
 * pre-create picker looks identical to the post-create editor.
 */
export function AmenityPickerGrid({
  selected,
  onToggle,
}: {
  selected: Set<string>;
  onToggle: (key: string) => void;
}) {
  return (
    <div className="amenities-grid">
      {AMENITIES.map((amenity) => {
        const isOn = selected.has(amenity.key);
        return (
          <button
            key={amenity.key}
            type="button"
            className={`amenity-chip ${isOn ? "on" : ""}`}
            onClick={() => onToggle(amenity.key)}
            aria-pressed={isOn}
          >
            <span className="amenity-icon">{amenity.icon}</span>
            <span className="amenity-label">{amenity.label}</span>
          </button>
        );
      })}
    </div>
  );
}
